// Programa Académico Preliminar — COPLAFT 2026 (fallback cuando el API no devuelve datos)
const programa_preliminar = {
    titulo: "Programa Académico Preliminar",
    evento: "V Congreso Latinoamericano de Prevención del Lavado de Activos y Financiamiento del Terrorismo",
    fecha: "21 y 22 de septiembre 2026",
    sede: "Hotel Barceló, Salón Las Naciones · Ciudad de Guatemala",
    organizadores: "Organizan: ABG · EBG · FELABAN · COPLAFT",
    dias: [
        {
            etiqueta: "Día 1",
            fecha: "Lunes 21 de septiembre",
            agenda: [
                {
                    hora: "07:00 – 08:00",
                    titulo: "Registro de participantes",
                    tipo: "registro",
                },
                {
                    hora: "08:00 – 08:30",
                    titulo: "Palabras de bienvenida e inauguración",
                    tipo: "inauguracion",
                    ponentes: [
                        "Erhard Schafer (Director Ejecutivo, ABG, Guatemala)",
                        "Representante de la Junta Monetaria y del Banco de Guatemala",
                        "Representante de la Superintendencia de Bancos (SIB), Guatemala",
                        "Giorgio Trettenero Castro (Secretario General, FELABAN, Perú)",
                    ],
                },
                {
                    hora: "08:30 – 09:30",
                    titulo: "Riesgos de LA/FT en Activos Virtuales y Stablecoins",
                    tipo: "conversatorio",
                    ponentes: [
                        "Geraldine Pacheco (Account Executive América Latina, Chainalysis, EE.UU.)",
                        "Pablo Pérez (Founder, RiskFlow Compliance Solutions, España)",
                    ],
                },
                {
                    hora: "09:30 – 10:15",
                    titulo: "Inteligencia Artificial aplicada al Compliance y Monitoreo Transaccional",
                    tipo: "conferencia",
                    ponentes: [
                        "Luis Ramiro Díaz Briceño (CEO, Risk Consulting Global Group, Colombia)",
                    ],
                },
                {
                    hora: "10:15 – 10:45",
                    titulo: "Coffee break & networking",
                    tipo: "cafe",
                },
                {
                    hora: "10:45 – 11:30",
                    titulo: "Beneficiario Final y Transparencia Corporativa. Avances en la normativa y adopción regional. Retos y Oportunidades",
                    tipo: "conferencia",
                    ponentes: [
                        "Daniel Fernando Bañados Maticorena (VP Corp. Gobierno & Cumplimiento, BAC Credomatic, Perú-Costa Rica)",
                    ],
                },
                {
                    hora: "11:30 – 12:30",
                    titulo: "Gestión de Riesgos de FPADM y Sanciones Financieras Internacionales. Qué ver y dónde debemos prestar atención",
                    tipo: "panel",
                    ponentes: [
                        "Representante de CITI",
                        "Roderick Schwarz (Director Principal, Aguirre Schwarz, Venezuela)",
                        "Moderadora: Carolina Moncada (Alumni and Client Services Specialist, FIBA, EE.UU.)",
                    ],
                },
                {
                    hora: "12:30 – 13:30",
                    titulo: "Almuerzo y networking",
                    tipo: "almuerzo",
                },
                {
                    hora: "13:30 – 14:15",
                    titulo: "Minería Ilegal, Delitos Ambientales y Lavado de Activos",
                    tipo: "conferencia",
                    ponentes: [
                        "Juan Carlos Medrano (Especialista AML, J&A Global Compliance, Venezuela/EE.UU.)",
                    ],
                },
                {
                    hora: "14:15 – 15:00",
                    titulo: "Ciberdelincuencia, Fraude Digital y Nuevas Amenazas Financieras",
                    tipo: "conferencia",
                    ponentes: ["Representante de Plus TI / ES"],
                },
                {
                    hora: "15:00 – 15:30",
                    titulo: "Coffee break & networking",
                    tipo: "cafe",
                },
                {
                    hora: "15:30 – 16:15",
                    titulo: "Preparación para Evaluaciones Mutuas y Supervisión Basada en Riesgo",
                    tipo: "conferencia",
                    ponentes: ["Diana Yon (Experta Técnica, GAFILAT, Guatemala)"],
                },
                {
                    hora: "16:15 – 17:15",
                    titulo: "Programas Anticorrupción y Cultura de Integridad Corporativa",
                    tipo: "panel",
                    ponentes: [
                        "Susan Paola Rojas (Exintendente IVE 2010-2012, Fundadora de Evalua Compliance, Facilitadora de la EBG, Guatemala)",
                        "Glenda Morales (II Vicepresidenta Comité COPLAFT 2026, Gerente de Cumplimiento Banco Promerica, Guatemala)",
                        "Paola de la Torre (Presidente Ejecutiva, GuateÍntegra, Guatemala)",
                        "Moderador: Rodrigo Moscoso (Presidente Comité COPLAFT, Panamá)",
                    ],
                },
                {
                    hora: "17:15",
                    titulo: "Cierre del primer día",
                    tipo: "fin",
                },
            ],
        },
        {
            etiqueta: "Día 2",
            fecha: "Martes 22 de septiembre",
            agenda: [
                {
                    hora: "07:45 – 08:00",
                    titulo: "Bienvenida",
                    tipo: "registro",
                },
                {
                    hora: "08:00 – 08:45",
                    titulo: "Fintech, Open Finance y Nuevos Riesgos Regulatorios",
                    tipo: "conferencia",
                    ponentes: ["Nicolás Franco (CEO LATAM & España, Socorro Partners, USA)"],
                },
                {
                    hora: "08:45 – 09:30",
                    titulo: "Trade-Based Money Laundering (TBML) y Comercio Internacional",
                    tipo: "conferencia",
                    ponentes: [
                        "Adrián Sánchez (Director América Latina y el Caribe, Crímenes Financieros y Cumplimiento, LexisNexis Risk Solutions, México-USA)",
                    ],
                },
                {
                    hora: "09:30 – 10:00",
                    titulo: "Coffee break & networking profesional",
                    tipo: "cafe",
                },
                {
                    hora: "10:00 – 10:45",
                    titulo: "Trata de Personas, Tráfico Ilícito de Migrantes y Flujos Financieros Ilícitos",
                    tipo: "conferencia",
                    ponentes: [
                        "Representante de la Intendencia de Verificación Especial (IVE), Guatemala",
                    ],
                },
                {
                    hora: "10:45 – 11:30",
                    titulo: "El futuro del Compliance no es solo automático, es inteligente",
                    tipo: "conferencia",
                    ponentes: [
                        "Carlos Andrés Aldana (VP de Cumplimiento, Grupo Bancolombia, Colombia / Washington D.C.)",
                    ],
                },
                {
                    hora: "11:30 – 12:15",
                    titulo: "Materiales de Uso Dual, Comercio Estratégico y Riesgos de FPADM",
                    tipo: "conferencia",
                    ponentes: ["Jamie Mickelson (Managing Director, Kroll, EE.UU.)"],
                },
                {
                    hora: "12:15 – 13:30",
                    titulo: "Almuerzo y networking",
                    tipo: "almuerzo",
                },
                {
                    hora: "13:30 – 14:15",
                    titulo: "Riesgos de LA/FT en Organizaciones Sin Fines de Lucro y Fundaciones de Interés Privado",
                    tipo: "conferencia",
                    ponentes: ["Representante — Mayra Rodríguez / Pirani"],
                },
                {
                    hora: "14:15 – 15:00",
                    titulo: "Compliance Transfronterizo y Cooperación Internacional entre Autoridades",
                    tipo: "conferencia",
                    ponentes: ["José Antonio Roca (Gerente General/CEO, Bantrab, Guatemala)"],
                },
                {
                    hora: "15:00 – 16:00",
                    titulo: "Ley Integral PLAFT: Del Reglamento a la Implementación",
                    tipo: "panel",
                    ponentes: [
                        "Susan Paola Rojas (Exintendente IVE 2010-2012, Fundadora de Evalua Compliance, Facilitadora de la EBG, Guatemala)",
                        "Mariano Rayo (Asesor, ABG, Guatemala)",
                        "Representante de Arias Law, Guatemala",
                        "Moderador: Alejandro Arriola (Abogado y Notario, Socio IBR Law & Consulting, Docente de la EBG, Guatemala)",
                    ],
                },
                {
                    hora: "16:00 – 17:00",
                    titulo: "Cultura de Cumplimiento, Responsabilidad de la Alta Gerencia y Gobierno Corporativo",
                    tipo: "cierre",
                    ponentes: [
                        "Daniel Gutiérrez (Director de Servicios Financieros Domésticos, Foodman CPAs & Advisors, USA)",
                        "Representante de la Superintendencia de Bancos (SIB), Guatemala",
                    ],
                },
                {
                    hora: "17:00 – 17:30",
                    titulo: "Conclusiones y Coffee break",
                    tipo: "fin",
                },
            ],
        },
    ],
};

export default programa_preliminar;
